import { render, staticRenderFns } from "./FeatureBox.vue?vue&type=template&id=76a98f30"
import script from "./FeatureBox.vue?vue&type=script&lang=js"
export * from "./FeatureBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports